// extracted by css-extract-rspack-plugin
export default {"cls1":"Header-cls1_XqP","cls2":"Header-cls2_IKO Header-cls1_XqP"};